<form class="m-h-12 m-v-8"
  [formGroup]="form">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreCritereRecherche' | translate }}</h3>

  <mat-form-field class="d-flex tour-interactif-step-4-step-0">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.transactionGdf.typeTransaction' | translate }}</mat-label>
    <mat-select formControlName="typeTransaction"
      multiple
      (closed)="selectTypeTransactionChanged()">
      <mat-option *ngFor="let typeTransaction of typeTransactionListeDeroulante"
        [value]="typeTransaction.codeTypeTransaction">
        {{typeTransaction.descriptionTypeTransaction}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="form.controls.typeTransaction.errors?.required">
      {{messageApplication.obligatoireTypeTransaction}}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-4-step-1">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.transactionGdf.statut' | translate }}</mat-label>
    <mat-select formControlName="statut"
      multiple>
      <mat-option *ngFor="let statut of statutListeDeroulante"
        [value]="statut.codeStatut">
        {{statut.nomStatut}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <h3>
    {{ 'sigt.integration.rechercheGdf.form.transactionGdf.localisation'| translate }}<span class="required">*</span>
  </h3>

  <mat-form-field class="d-flex tour-interactif-step-4-step-2">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.transactionGdf.municipalite' | translate }}</mat-label>
    <mat-select formControlName="municipalite"
      multiple
      appFilterableMatSelect>
      <mat-option *ngFor="let municipalite of municipaliteListeDeroulante"
        [value]="municipalite.codeMunicipalite">
        {{municipalite.nomMunicipalite}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-4-step-3">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.transactionGdf.mrc' | translate }}</mat-label>
    <mat-select formControlName="mrc"
      multiple
      (closed)="selectMrcChange()"
      appFilterableMatSelect>
      <mat-option *ngFor="let mrc of mrcListeDeroulante"
        [value]="mrc.codeMrc">
        {{mrc.nomMrc}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-4-step-4">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.transactionGdf.regionAdministrative' | translate }}</mat-label>
    <mat-select formControlName="regionAdministrative"
      multiple
      (closed)="selectRegionChange()"
      appFilterableMatSelect>
      <mat-option *ngFor="let regionAdministrative of regionsAdministrativeListeDeroulante"
        [value]="regionAdministrative.codeRegion">
        {{regionAdministrative.nomRegion}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="boutons-en-grille">
    <button mat-raised-button
      type="button"
      class="clear-search-button tour-interactif-gdf-reinitialiser"
      (click)="initialiserChamps()">
      {{ 'sigt.global.boutons.reinitialiser' | translate }}
    </button>

    <button mat-raised-button
      class="search-button tour-interactif-gdf-rechercher"
      [disabled]="!form.valid"
      (click)="rechercher()"
      color="primary">
      {{ 'sigt.global.boutons.rechercher' | translate }}
    </button>
  </div>
</form>